if (!customElements.get("product-form")) {
  class t extends HTMLElement {
    constructor() {
      (super(),
        (this.form = this.querySelector("form")),
        (this.variantIdInput.disabled = !1),
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        (this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer")),
        (this.submitButton = this.querySelector('[type="submit"]')),
        (this.submitButtonText = this.submitButton.querySelector("span")),
        document.querySelector("cart-drawer") &&
          this.submitButton.setAttribute("aria-haspopup", "dialog"),
        (this.hideErrors = "true" === this.dataset.hideErrors));
    }
    onSubmitHandler(t) {
      console.log(t);

      t.preventDefault();
      let e = this.closest("product-info");
      e || (e = document.querySelector("product-info"));
      const r = e?.querySelectorAll(
        ".dbtfy-customizable-product__input.required",
      );
      var s = !0;
      let i = !1;
      if (
        (r?.forEach((t) => {
          ("checkbox" != t.getAttribute("type") ||
            t.checked ||
            (t.closest(".checkbox").classList.add("error"), (s = !1)),
            "text" != t.getAttribute("type") ||
              t.value ||
              (t.closest(".field").classList.add("error"), (s = !1)),
            s ||
              i ||
              (t.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              }),
              (i = !0)));
        }),
        !s)
      )
        return;
      if ("true" === this.submitButton.getAttribute("aria-disabled")) return;
      (this.handleErrorMessage(),
        this.submitButton.setAttribute("aria-disabled", !0),
        this.submitButton.classList.add("loading"),
        this.querySelector(".loading__spinner")?.classList.remove("hidden"));
      const o = fetchConfig("javascript");
      ((o.headers["X-Requested-With"] = "XMLHttpRequest"),
        delete o.headers["Content-Type"]);
      const a = new FormData(this.form);
      console.log(a);

      (t.submitter.id.endsWith("sticky-add-to-cart") &&
        r &&
        r.forEach((t) => {
          a.append(t.getAttribute("name"), t.value);
        }),
        this.cart &&
          (a.append(
            "sections",
            this.cart.getSectionsToRender().map((t) => t.id),
          ),
          a.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement)));
      let n = !1,
        c = !1,
        d = a.get("id"),
        u = !1;
      const l = e?.querySelector("dbtfy-product-quantity-break");
      if (l) {
        const t = e?.querySelector(
            ".dbtfy-product-quantity-break__radio:checked",
          ),
          r = t?.closest(".dbtfy-product-quantity-break");
        if (r) {
          let e = 1;
          (l.data.enable_variant_selector
            ? (t
                .closest(".dbtfy-product-quantity-break")
                .querySelectorAll("select")
                .forEach((t, e) => {
                  (a.set(`items[${e}][id]`, `${t.selectedOptions[0].id}`),
                    a.set(`items[${e}][quantity]`, 1));
                }),
              (e = t.value))
            : (a.set("items[0][id]", a.get("id")),
              a.set("items[0][quantity]", a.get("quantity"))),
            (u = t?.dataset.discountCode || !1));
          const s = r?.querySelector(".product-quantity-break__gift");
          ((n = s?.dataset.freeProductId),
            n &&
              (a.set(`items[${e}][id]`, n),
              a.set(`items[${e}][quantity]`, s.dataset.freeProductQuantity)),
            a.delete("quantity"),
            a.delete("id"),
            (c = !0));
        }
      }
      (this.dataset.discountCode && (u = this.dataset.discountCode),
        (o.body = a),
        fetch(`${routes.cart_add_url}`, o)
          .then((t) => t.json())
          .then((t) => {
            if (t.status) {
              (publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: a.get("id"),
                errors: t.errors || t.description,
                message: t.message,
              }),
                this.handleErrorMessage(t.description));
              const e = this.submitButton.querySelector(".sold-out-message");
              if (!e) return;
              return (
                this.submitButton.setAttribute("aria-disabled", !0),
                this.submitButtonText.classList.add("hidden"),
                e.classList.remove("hidden"),
                void (this.error = !0)
              );
            }
            ("page" == Debutify.settings.cart_type &&
              Debutify.settings.cart_type_action &&
              0 == Debutify.settings.dbtfy_upsell_popup &&
              !u &&
              (window.location = window.routes.cart_url),
              u && this.executeDiscount(u));
            let e = t;
            (c &&
              ((e = t.items[0] ? { ...t.items[0] } : {}),
              (e.sections = t.sections)),
              this.error ||
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: d,
                  cartData: e,
                }),
              (this.error = !1));
            const r = this.closest("quick-add-modal");
            r
              ? (document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(
                        e,
                        Debutify.settings.cart_type_action,
                      );
                    });
                  },
                  { once: !0 },
                ),
                r.hide(!0))
              : this.cart.renderContents(e, Debutify.settings.cart_type_action);
          })
          .catch((t) => {
            console.error(t);
          })
          .finally(() => {
            (this.submitButton.classList.remove("loading"),
              this.cart &&
                this.cart.classList.contains("is-empty") &&
                this.cart.classList.remove("is-empty"),
              this.error || this.submitButton.removeAttribute("aria-disabled"),
              this.querySelector(".loading__spinner")?.classList.add("hidden"));
          }));
    }
    executeDiscount(t) {
      fetch(`/discount/${t}`, {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      })
        .then((t) => {
          t.ok || console.error("Failed to apply discount: " + t.statusText);
        })
        .catch((t) => {
          console.error("Error applying discount:", t);
        })
        .finally(() => {
          "page" === Debutify.settings.cart_type
            ? window.location.reload()
            : "drawer" === Debutify.settings.cart_type &&
              fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((t) => t.text())
                .then((t) => {
                  const e = new DOMParser()
                    .parseFromString(t, "text/html")
                    .querySelector("#shopify-section-cart-drawer #CartDrawer");
                  document
                    .querySelector("#shopify-section-cart-drawer #CartDrawer")
                    .replaceWith(e);
                })
                .catch((t) => {
                  console.error(t);
                });
        });
    }
    handleErrorMessage(t = !1) {
      this.hideErrors ||
        ((this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper")),
        this.errorMessageWrapper &&
          ((this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              ".product-form__error-message",
            )),
          this.errorMessageWrapper.toggleAttribute("hidden", !t),
          t && (this.errorMessage.textContent = t)));
    }
    toggleSubmitButton(t = !0, e) {
      t
        ? (this.submitButton.setAttribute("disabled", "disabled"),
          e && (this.submitButtonText.textContent = e))
        : (this.submitButton.removeAttribute("disabled"),
          (this.submitButtonText.textContent =
            window.variantStrings.addToCart));
    }
    get variantIdInput() {
      return (
        this.form.querySelector("[name=id]") ||
        this.form.querySelector('[name="id[]"]')
      );
    }
  }
  if (
    (customElements.define("product-form", t),
    !customElements.get("sticky-product-form") &&
      customElements.get("product-form"))
  ) {
    class e extends t {
      constructor() {
        super();
      }
    }
    customElements.define("sticky-product-form", e);
  }
}
